import React from "react";
import Forwardingimage11 from "./whatsapp.png";


const WhatsAppIcon = () => {
  const whatsappLink = "https://api.whatsapp.com/send?phone=923008261571"; // replace with your number

  return (
   <a
  href={whatsappLink}
  target="_blank"
  rel="noopener noreferrer"
  style={{
    position: "fixed",
    top: "90%",
    right: "15px",
    transform: "translateY(-50%)",
    // backgroundColor: "#25D366",
    padding: "12px",
    borderRadius: "50%",
    boxShadow: "0 4px 8px rgba(0,0,0,0.3)",
    zIndex: 1000,
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  }}
>
  <img
    src={Forwardingimage11}
    alt="WhatsApp"
    style={{
      width: "32px",
      height: "32px",
      objectFit: "contain",
    }}
  />
</a>

  );
};

export default WhatsAppIcon;